export const MuiExpansionPanel = {
  root: {
    'border': 'none',
    'box-shadow': 'none',
    '&:before': { opacity: 0 },
  },
  expanded: {
    margin: 0,
  },
}

export const MuiExpansionPanelSummary = {
  root: {
    'padding': 0,
    'min-height': 0,
    'margin': 0,
  },
  content: {
    display: 'block',
    margin: 0,
  },
  expanded: {
    'min-height': 0,
    'margin': 0,
  },
  expandIcon: {
    top: '20%',
  },
}

export const MuiExpansionPanelDetails = {
  root: {
    display: 'block',
    padding: 0,
  },
}
